import type { CustomerKidStorePayload } from '@entities/customer'
import type { ApiResponse } from '@shared/api'

import { useCustomerStore } from '@entities/customer'
import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface CreatedKid {
  id: number
}

/** `POST /admin-api/kids` — creates the kid, with its first discipline when `discipline_code` is set. */
export const useCustomerKidStoreApi = async (payload: CustomerKidStorePayload): Promise<CreatedKid | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const customerStore = useCustomerStore()

  const url = useAdminRoutes('admin.customer.kid-store')

  customerStore.trackProcessing(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.post<ApiResponse>(url, payload)
    const kid: CreatedKid | null = data.data || null

    if (!data.success || !kid) {
      toast.error(data.message)
      return null
    }

    return kid
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return null
  } finally {
    customerStore.trackProcessing(false)
  }
}
